// #region Imports
import { defineComponent } from "vue";
import { Wormhole } from 'portal-vue';
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-akbb-layout',
    // #endregion
    // #region Properties
    props: {
        widthMode: {
            type: String,
            required: false,
            default: 'default'
        },
    },
    computed: {
        currentYear() {
            return new Date().getFullYear();
        },
        hasUser() {
            return this.$host.store.get("session").isAuthenticated;
        },
        currentUser() {
            return this.$host.store.get("session").currentUser;
        },
        userDisplayName() {
            return this.currentUser?.displayName ?? '';
        },
        pageTitle() {
            return host.pageMeta.title;
        },
        pageCenter() {
            return host.pageMeta.options.center;
        },
        userName() {
            return this.currentUser?.userName ?? '';
        },
        mainMenuEntries() {
            return this.makeNodesExpaned(this.$host.store.getter("navigation/getMenu", "MAIN"));
        },
        footerMenuEntries() {
            return this.makeNodesExpaned(this.$host.store.getter("navigation/getMenu", "FOOTER"));
        },
        socialMediaMenuEntries() {
            return this.$host.store.getter("navigation/getMenu", "SOCIALMEDIA");
        },
        topMenuEntries() {
            return this.$host.store.getter("navigation/getMenu", "TOP");
        },
        hasCommands() {
            return (Wormhole.getContentForTarget('command-bar', true) ?? []).length > 0;
        },
        hasBreadcrumb() {
            return this.$host.store.getter('navigation/getBreadcrumb').length > 0;
        }
    },
    // #endregion
    // #region Constructor
    mounted() {
        //window.addEventListener("scroll", this.onResize);
        //window.addEventListener("resize", this.onResize);
    },
    beforeUnmount() {
        //window.removeEventListener("scroll", this.onResize);
        //window.removeEventListener("resize", this.onResize);
    },
    // #endregion
    // #region Methods
    methods: {
        getMenulinkUrl(item) {
            return (item.actionCommand ? item.actionCommand : 'to://' + item.address);
        },
        makeNodesExpaned(nodes) {
            utils.routing.setNodesExpanedIfHasActiveRoute(this.$route.path, nodes, (f) => f.actionCommand ? f.actionCommand : 'to://' + f.address);
            return nodes;
        },
        onMobileNavToogle(event) {
            event.stopPropagation();
            this.$host.pageMeta.toogleMobileNav();
        },
        onResize() {
            //Vars
            let tHeader = this.$refs.akbheader;
            //Change
            if (window.scrollY > 20) {
                tHeader.classList.add("akb-fixed");
            }
            else {
                tHeader.classList.remove("akb-fixed");
            }
        }
    },
    // #endregion
});
// #endregion
